// Modules
import React from 'react';
import moment from 'moment';
// @ts-ignore
import { LocalizationContext } from 'react-localize';

// Styles
import './CheckAvailabilityHotelInformation.sass';

// Interfaces
import ResortResult from 'Interfaces/ResortResultInterface';
import {AvailableResult} from 'Interfaces/ResortResultInterface';
import FormData from "Interfaces/FormDataInterface";
import {Tip} from "Interfaces/TipInterface";
import SelectedFilters from "Interfaces/SelectedFiltersInterface";
import FilterResult from "Interfaces/FilterResultInterface";

// Components
import ToolTip from "Generic/ToolTip";

type ResultItemState = {
  selectedDate: Date|null,
  dateSelected: boolean
}

type Props = {
  result: ResortResult;
  form: FormData;
  accessible: string;
  hearing: boolean;
  openModal: (propCode: string) => void;
  propCode: (propCode:string)=>void
  onFilterSelect(name: string, item: any): void;
  selectedFilters: SelectedFilters;
  filters: FilterResult;
}

class CheckAvailabilityHotelInformation extends React.Component<Props, ResultItemState> {
  pointStartingTip: [Tip]= [
    {
      label: "",
      desc: "static.content.tip.points-starting"
    }
  ];

  constructor(props:Props) {
    super(props)
    this.propCodeModal = this.propCodeModal.bind(this)
  }

  propCodeModal(boolean:boolean, propCode:string) {
    this.props.openModal(propCode)
    this.props.propCode(this.props.result.propertyCode)
  }

  /**
   * Select/De-select a points pill
   *
   * When a room type pill is selected, filter the 'Available Villas' section
   * to include the room type
   *
   * This will also select/de-select the corresponding room-type filter
   * in the <FilterResults /> component
   */
  pointsPillClicked(roomType: string, disabled: boolean) {
    if (disabled) return false;
    
    // Select/De-select the room-type filter
    this.props.onFilterSelect("roomType", roomType);
  }

  render() {
    const { localize } = this.context;

    let message;
    let startDate = new Date(this.props.form.startDate);

    if (this.props.form.flexibleSearch) {
      message=(<p className="flexible-on line-row">
                <span className="bold">Flexible On:</span> {moment(startDate).format("MMM YYYY")}
              </p>);
    } else {
      let start = moment(startDate);
      let end = moment(startDate).add(this.props.form.numNights, 'd');
      message = (<React.Fragment>
                  <p className="line-row"><span className="bold">Check in:</span> {start.format("DD MMM YYYY")}</p>
                  <p className="line-row"><span className="bold">Check out:</span> {end.format("DD MMM YYYY")}</p>
                </React.Fragment>);
    }

    let accessibilityVal = this.props.form.accessibility;

    const selectedRoomFilters = this.props.selectedFilters["roomType"].filters;

    return (
      <React.Fragment>

        <div className="cahi-wrapper row villa-section">
          <div className="four columns resort-image">
            <button data-id={this.props.result.propertyCode.toLowerCase()} onClick={(e)=>this.propCodeModal(true, this.props.result.propertyCode)} className="img-btn">
              <img className="resort-result-image" src={this.props.result.resortImage} alt=""/>
            </button>
          </div>

          <div className="eight columns resort-info">
            <button data-id={this.props.result.propertyCode.toLowerCase()} onClick={(e)=>this.propCodeModal(true, this.props.result.propertyCode)} className="rn-btn">{this.props.result.name}</button>
            <p className="address-line">
              {this.props.result.city}, {(this.props.result.state && this.props.result.state != "NO-STATE") ? `${this.props.result.state},`  : "" }{" "}
              {this.props.result.country}
            </p>
            <div className="activity-wrapper">
              {
                this.props.result.activities.map(activity => {
                    let url = activity.iconURL;
                    return (
                    <div key={url} className="icon">
                        <img className="activity-icon" src={url} alt=""/>
                        <p className="activity-icon-text">{activity.name}</p>
                    </div>
                    )
                })
              }
            </div>

            <div className="arrival-info">
              <p className="ai-vc">{localize('static.content.ayp-arrival-information')}</p>
              {message}

              <div className="nights-guests line-row">
                <div className="of-nights">
                  <p><span className="bold">{localize('static.content.num-of-nights')}: </span>
                    {this.props.form.numNights}
                  </p>
                </div>
                <div className="of-guests">
                  <p><span className="bold">{localize('static.content.num-of-guests')}: </span>
                    {this.props.form.numGuests}
                  </p>
                </div>
              </div>
            </div>
            <div className="accessibility-options">
              <p className={(accessibilityVal ?  "line-row" : "hide line-row")}>
                <span className={"accessibility bold"}> Accessibility: </span>
                <span className="accessibility-details">{this.props.accessible}</span>
              </p>

              <p className={(this.props.form.hearing ?  "line-row" : "hide line-row")}>
                <span className={"hearing-accessible bold"}>Hearing Accessible: </span>
                <span className="hearing-accessible-details">{this.props.hearing ? "Yes":""}</span>
              </p>

            </div>
            </div>
        </div>

        <div className="points-starting">
          <div>
            <p className='heading'>{localize("static.content.points-starting")}:</p>
            <div className="points-starting-tooltip">
              <ToolTip
                tabIndex={0}
                tip={this.pointStartingTip}
                id='points-starting-at'
                useRefToPosition={false}
              >
                <span className="question-icon">{"?"}</span>
              </ToolTip>
            </div>
          </div>
          <div className='points-divider'/>

          <div className="points-row">

            {this.props.filters["roomType"].map((room, i )=> {
              const classNames = ["points-amount"];

              // selected
              const selected = selectedRoomFilters.indexOf(room.value) !== -1;
              if (selected) classNames.push("selected");

              // disabled
              // TODO: remove the following code, once we can select more than one roomTypeFilter
              // back-end can't supply minimumPoints for other roomTypes if one roomType filter is applied
              // remove from checkbox filters too
              // temp fix allowing user to select only one roomType filter
              // || (!selected && selectedRoomFilters.length > 0)
              const disabled = false;
              // const disabled = room.minimumPoints === 0 || (!selected && selectedRoomFilters.length > 0) ;
              // if (disabled) classNames.push("disabled");

              return (
                <div
                  key={i}
                  className={classNames.join(" ")}
                  onClick={() => this.pointsPillClicked(room.value, disabled)}
                >
                  <p>
                    {room.description}{disabled || room.minimumPoints === 0 ? "" : `: ${room.minimumPoints}`}
                  </p>
                </div>
              );
            })}

          </div>
        </div>
      </React.Fragment>
    )
  }
}

CheckAvailabilityHotelInformation.contextType = LocalizationContext;

export default CheckAvailabilityHotelInformation
